export const SHORTCUTS_ALIASES_LIST = [
  '{win}',
  '{arrow-right}',
  '{arrow-left}',
  '{arrow-up}',
  '{arrow-down}',
  '{cmd}',
];
